<template>
  <div>
    <div class="row mt-3">
      <div class="fw-700 mb-2">Y lệnh</div>
      <div class="w-1/4 mt-2 relative">
        <label class="fw-700">Chọn kho thuốc</label>
        <el-select class="w-full" v-model="inventoryMedicine" filterable placeholder="Chọn kho thuốc" remote
          reserve-keyword @change="handleChangeInventory" :remote-method="getInventoryMedicines" :loading="isLoading">
          <el-option v-for="item in listInventory" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </div>
      <div class="w-3/4 mt-2">
        <label class="fw-700">Chọn thuốc</label>
        <div class="flex items-center">
          <SelectMedicine class="w-full" :clearCount="clearCount" :medicine="form.medicine"
            :inventoryMedicine="inventoryMedicine" :listInventory="listInventory" @onClearMedicine="handleClearData()"
            @onUpdateMedicine="handleUpdateMedicine" />
          <el-button class="ml-2" type="primary" icon="el-icon-plus" @click="onMedicineAdd" :disabled="!form.medicine">
            Thêm thuốc
          </el-button>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="flex items-center w-full">
          <div class="flex-1">
            <label class="fw-700">Thông tin Y lệnh</label>
          </div>
          <!-- editor is editable by default; removed toggle button -->
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <TiptapEditor ref="medicalOrderEditorPreview" v-model="contentLocal"
          classProp="min-h-100" />
      </div>
    </div>
  </div>
</template>
<script>
import TiptapEditor from '@/components/Editors/Tiptap'
import SelectMedicine from '@/components/PatientVisit/Prescription/SelectMedicine.vue'
import appUtils from '@/utils/appUtils'

const dataDefault = {
  medicine: null,
  dose: '',
  amount: '',
  amount_unit: '',
  volume: '',
  instructions: '',
  start_time: '',
  end_time: ''
}

const INVENTORY_EXTERNAL = {
  name: 'Kho tham chiếu',
  id: 0,
  isExternal: true
}

export default {
  name: 'CreateYLenh',
  components: {
    TiptapEditor,
    SelectMedicine
  },
  props: {
    formCreate: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }

  },
  data () {
    return {
      contentLocal: '',
      activeNames: ['1'],
      clearCount: 0,
      inventoryMedicine: null,
      listInventory: [INVENTORY_EXTERNAL],
      isLoading: false,
      prescriptionLocal: [],
      // editor is editable by default
      _suppressFormCreateWatch: false,
      _suppressPrescriptionWatch: false,
      _lastChangeFromEditor: false,
      _hasPendingChanges: false,
      _pendingMerged: null,
      form: {
        ...dataDefault
      }
    }
  },
  async created () {
    const parsedFromJson = this.formCreate.content_json ? JSON.parse(appUtils.isJSON(this.formCreate.content_json) ? this.formCreate.content_json : []) : []
    if (this.type === 'create') {
      this.prescriptionLocal = []
      this._suppressFormCreateWatch = true
      this.updateMedicalOrderTable()
      this.$nextTick(() => {
        this._suppressFormCreateWatch = false
      })
    } else if (this.formCreate.content) {
      this._suppressPrescriptionWatch = true
      const normalized = this.normalizeIncomingHtml(this.formCreate.content || '')
      this.prescriptionLocal = this.parsePrescriptionFromHtml(normalized)
      this.contentLocal = normalized
      this.$nextTick(() => { this._suppressPrescriptionWatch = false })
    } else if (parsedFromJson && parsedFromJson.length) {
      this._suppressPrescriptionWatch = true
      this.prescriptionLocal = parsedFromJson
      this.$nextTick(() => { this._suppressPrescriptionWatch = false })
    } else {
      this.prescriptionLocal = []
    }
    await this.getInventoryMedicines()
  },
  watch: {
    formCreate: {
      handler (data) {
        if (this._suppressFormCreateWatch) return
        if (data.content && this.contentLocal && data.content === this.contentLocal) return
        const parsedFromJson = data.content_json ? JSON.parse(appUtils.isJSON(data.content_json) ? data.content_json : []) : []
        if (this.type === 'create') {
          this.prescriptionLocal = []
          this._suppressFormCreateWatch = true
          this.updateMedicalOrderTable()
          this.$nextTick(() => { this._suppressFormCreateWatch = false })
        } else if (data.content) {
          if (this._lastChangeFromEditor) {
            this._lastChangeFromEditor = false
          } else {
            this.prescriptionLocal = this.parsePrescriptionFromHtml(this.normalizeIncomingHtml(data.content || ''))
            this.contentLocal = this.normalizeIncomingHtml(data.content || '')
            this.$nextTick(() => {
              this.$refs.medicalOrderEditorPreview.editor.commands.setContent(this.contentLocal)
            })
          }
        } else if (parsedFromJson && parsedFromJson.length) {
          this._suppressPrescriptionWatch = true
          this.prescriptionLocal = parsedFromJson
          this.$nextTick(() => { this._suppressPrescriptionWatch = false })
        } else {
          this.prescriptionLocal = []
        }
      },
      deep: true,
      immediate: true
    },
    prescriptionLocal: {
      handler () {
        if (this._suppressPrescriptionWatch) return
        this.updateMedicalOrderTable()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    normalizeIncomingHtml (html) {
      if (!html) return ''
      try {
        let unescaped = html.replace(/\\u([0-9a-fA-F]{4})/g, (_, h) => String.fromCharCode(parseInt(h, 16)))
        const textarea = document.createElement('textarea')
        textarea.innerHTML = unescaped
        unescaped = textarea.value
        return unescaped
      } catch (e) {
        return html
      }
    },
    sanitizeForEmit (item) {
      if (!item) return {}
      return { ...item }
    },
    commitContentToParent () {
      let parsedFromEditor = null
      const editor = this.$refs.medicalOrderEditorPreview && this.$refs.medicalOrderEditorPreview.editor
      // always read editor content when available (editor is editable by default)
      if (editor && typeof editor.getHTML === 'function') {
        const liveHtml = editor.getHTML()
        this.contentLocal = liveHtml
        parsedFromEditor = this.parsePrescriptionFromHtml(liveHtml)
        if (parsedFromEditor && parsedFromEditor.length) {
          this._suppressPrescriptionWatch = true
          this.prescriptionLocal = parsedFromEditor
          this._suppressPrescriptionWatch = false
        }
      }

      this._suppressFormCreateWatch = true
      if (parsedFromEditor && parsedFromEditor.length) {
        this.formCreate.content = this.contentLocal
        this.formCreate.content_json = JSON.stringify(parsedFromEditor.map(this.sanitizeForEmit))
        this._hasPendingChanges = false
        this._pendingMerged = null
      } else if (this._hasPendingChanges && this._pendingMerged) {
        this.formCreate.content = this.contentLocal
        this.formCreate.content_json = JSON.stringify(this._pendingMerged.map(this.sanitizeForEmit))
        this._hasPendingChanges = false
        this._pendingMerged = null
      } else {
        this.formCreate.content = this.contentLocal
        this.formCreate.content_json = JSON.stringify(this.prescriptionLocal.map(this.sanitizeForEmit))
      }
      this.$emit('commit', { content: this.formCreate.content, content_json: this.formCreate.content_json })
      this.$nextTick(() => { this._suppressFormCreateWatch = false })
    },
    commitEditorContent (mergedArray) {
      this._suppressFormCreateWatch = true

      this.formCreate.content = this.contentLocal
      this.formCreate.content_json = JSON.stringify((mergedArray || []).map(this.sanitizeForEmit))
      this.$nextTick(() => { this._suppressFormCreateWatch = false })
    },
    async getInventoryMedicines (search) {
      try {
        const params = {
          org_id: this.$globalClinic.org_id,
          page_num: 1,
          page_size: 1000,
          keyword: search,
          ws_id: this.$globalClinic.id,
          type: 1
        }

        const response = await this.$rf.getRequest('DoctorRequest').getInventoryMedicines(params)
        const responseData = response.data.data || []
        responseData.push(INVENTORY_EXTERNAL)
        this.listInventory = responseData
      } catch (error) {
        console.log(error)
      }
    },
    handleChangeInventory () {
      this.clearCount++
    },
    async handleCheckAvailable (data) {
      let isAvai = true

      if (data.amount === '' || data.amount == null) {
        return true
      }

      const amountNum = Number(data.amount)
      if (!Number.isFinite(amountNum) || amountNum <= 0) {
        this.$message({
          message: this.$t('lbl_amount_required'),
          type: 'warning'
        })
        return
      }

      if (Number(data.qty) < Number(data.amount)) {
        await this.$confirm('Tổng số lượng đang vượt quá số lượng tồn kho, bạn có muốn thêm thuốc vào đơn?', this.$t('Cảnh báo'), {
          confirmButtonText: 'Xác nhận',
          cancelButtonText: 'Huỷ',
          type: 'warning'
        })
          .then(() => {
            isAvai = true
          })
          .catch(() => {
            isAvai = false
          })
      }
      return isAvai
    },
    async onMedicineAdd () {
      const isAvai = await this.handleCheckAvailable(this.form)
      if (!isAvai) return

      if (!this.form.medicine) return
      const localItem = { ...this.form }
      this._lastChangeFromEditor = false

      this._suppressPrescriptionWatch = true
      this.prescriptionLocal.push(localItem)
      this.appendRowToTableHtml(localItem)
      this.form = { ...dataDefault }
      this.$nextTick(() => { this._suppressPrescriptionWatch = false })
    },

    // toggle behavior removed; editor is editable by default
    handleGetMedicineName (medicine) {
      const medicineName = medicine?.name || medicine?.product_info?.name || ''
      const activeIngredient = medicine?.active_ingredient || medicine?.product_info?.active_ingredient_info?.name || ''
      const quality = medicine?.concentration || medicine?.product_info?.quality || ''

      return `${activeIngredient} ${quality} ${medicineName ? `(${medicineName})` : ''}`
    },
    handleUpdateMedicine (medicine) {
      this.handleClearData()
      this.form.medicine = medicine
      this.form.amount_unit = medicine.product_info?.isExternal ? medicine.product_info?.unit_id : this.getUnit(medicine.product_info)
      this.form.avail_qty = medicine.avail_qty
      this.form.qty = medicine.qty

      const conc = medicine.concentration || medicine.product_info?.concentration || ''
      const quality = medicine.quality || medicine.product_info?.quality || ''
      let doseVal = ''
      if (conc && quality) doseVal = `${conc} / ${quality}`
      else if (conc) doseVal = conc
      else if (quality) doseVal = quality
      this.form.dose = doseVal

      this.form.amount = 1

      this.form.volume = medicine.volume || medicine.product_info?.volume || ''
    },
    handleClearData () {
      this.form.medicine = null
      this.form.amount = ''
      this.form.amount_unit = ''
      this.form.dose = ''
      this.form.volume = ''
      this.form.instructions = ''
      this.form.start_time = ''
      this.form.end_time = ''
      this.form = { ...dataDefault }
    },
    handleDeleteMedicine (row) {
      this._lastChangeFromEditor = false
      let idx = this.prescriptionLocal.indexOf(row)
      if (idx === -1) {
        const nameMatch = (r) => (r?.medicine?.product_info?.name || '').toString().trim()
        idx = this.prescriptionLocal.findIndex(p => nameMatch(p) === nameMatch(row) && String(p.dose || '') === String(row.dose || '') && String(p.amount || '') === String(row.amount || ''))
      }
      this._suppressPrescriptionWatch = true
      if (idx >= 0) {
        this.prescriptionLocal = this.prescriptionLocal.filter((_, i) => i !== idx)
        const removed = this.deleteRowFromTableForPrescription(row, idx)
        if (!removed) {
          this.updateMedicalOrderTable()
        }
      } else {
        this.updateMedicalOrderTable()
      }
      this.$nextTick(() => { this._suppressPrescriptionWatch = false })
    },

    appendRowToTableHtml (pres) {
      if (!pres) return
      const medName = pres.medicine?.product_info?.name || ''
      const doseHtml = `<p style="text-align: center;margin-bottom:0;">${pres.dose || ''}</p>`
      const amountHtml = `<p style="text-align: center;margin-bottom:0;">${pres.amount === '' || pres.amount == null ? '' : pres.amount}</p>`
      const volumeHtml = `<p style="text-align: center;margin-bottom:0;">${pres.volume || ''}</p>`
      const instructionsHtml = `<p style="margin-bottom:0;">${pres.instructions || ''}</p>`
      const startHtml = `<p style="text-align: center;margin-bottom:0;">${pres.start_time || ''}</p>`
      const endHtml = `<p style="text-align: center;margin-bottom:0;">${pres.end_time || ''}</p>`

      const newRow = `
        <tr>
          <td style="padding:8px; text-align:left"><p style="margin-bottom:0;">${medName}</p></td>
          <td style="padding:8px; text-align:center">${doseHtml}</td>
          <td style="padding:8px; text-align:center">${amountHtml}</td>
          <td style="padding:8px; text-align:center">${volumeHtml}</td>
          <td style="padding:8px; text-align:left">${instructionsHtml}</td>
          <td style="padding:8px; text-align:center">${startHtml}</td>
          <td style="padding:8px; text-align:center">${endHtml}</td>
        </tr>`

      const parser = new DOMParser()
      const doc = parser.parseFromString(this.contentLocal || '', 'text/html')
      const tbody = doc.querySelector('tbody')
      if (tbody) {
        tbody.insertAdjacentHTML('beforeend', newRow)
        const container = doc.body.innerHTML
        this.contentLocal = container
        this._hasPendingChanges = true
        this._pendingMerged = this.prescriptionLocal.slice()
        this.$refs.medicalOrderEditorPreview.editor.commands.setContent(this.contentLocal)

        return
      }
      this.updateMedicalOrderTable()
    },
    deleteRowFromTableForPrescription (row, indexHint) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(this.contentLocal || '', 'text/html')
      const tbody = doc.querySelector('tbody')
      if (!tbody) return false
      const rows = Array.from(tbody.querySelectorAll('tr'))
      const targetText = (row?.medicine?.product_info?.name || '').toString().trim()
      let foundIdx = -1
      if (typeof indexHint === 'number' && indexHint >= 0 && indexHint < rows.length) {
        const candidate = rows[indexHint]
        if ((candidate.textContent || '').includes(targetText)) foundIdx = indexHint
      }
      if (foundIdx === -1) {
        for (let i = 0; i < rows.length; i++) {
          const t = (rows[i].textContent || '').trim()
          if (!t) continue
          if (t.includes(targetText) && t.includes(String(row.dose || '')) && t.includes(String(row.amount || ''))) {
            foundIdx = i
            break
          }
        }
      }
      if (foundIdx === -1) return false
      const toRemove = rows[foundIdx]
      toRemove.parentNode.removeChild(toRemove)
      const container = doc.body.innerHTML
      this.contentLocal = container
      this._hasPendingChanges = true
      this._pendingMerged = this.prescriptionLocal.slice()
      this.$refs.medicalOrderEditorPreview.editor.commands.setContent(this.contentLocal)
      return true
    },
    updateMedicalOrderTable () {
      const dataRows = Array.isArray(this.prescriptionLocal) ? this.prescriptionLocal : []

      let rows = dataRows.map(item => {
        return `
          <tr>
            <td><p style="margin-bottom:0;">${item.medicine?.product_info?.name || ''}</p></td>
            <td><p style="text-align: center;margin-bottom:0;">${item.dose || ''}</p></td>
            <td><p style="text-align: center;margin-bottom:0;">${item.amount === '' || item.amount == null ? '' : item.amount}</p></td>
            <td><p style="text-align: center;margin-bottom:0;">${item.volume || ''}</p></td>
            <td><p style="margin-bottom:0;">${item.instructions || ''}</p></td>
            <td><p style="text-align: center;margin-bottom:0;">${item.start_time || ''}</p></td>
            <td><p style="text-align: center;margin-bottom:0;">${item.end_time || ''}</p></td>
          </tr>
        `
      }).join('')

      const tableHeader = `
        <table style="min-width: 810px;">
          <colgroup>
            <col style="width: 228px;"/>
            <col style="width: 100px;"/>
            <col style="width: 89px;"/>
            <col style="width: 91px;"/>
            <col style="width: 252px;"/>
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th colspan="7"><p style="text-align: center; margin:0">Y LỆNH</p></th>
            </tr>
            <tr>
              <th><p style="text-align: center; margin:0">Thuốc điều trị</p></th>
              <th><p style="text-align: center; margin:0">Liều (mg)</p></th>
              <th><p style="text-align: center; margin:0">Số lượng</p></th>
              <th><p style="text-align: center; margin:0">Thể tích</p></th>
              <th><p style="text-align: center; margin:0">Hướng dẫn thực hiện</p></th>
              <th><p style="text-align: center; margin:0">Giờ bắt đầu</p></th>
              <th><p style="text-align: center; margin:0">Giờ kết thúc</p></th>
            </tr>
          </thead>
          <tbody>
      `

      const tableFooter = `
          </tbody>
        </table>
      `

      const fullTable = `<div style="text-align:center; overflow:auto">${tableHeader}${rows}${tableFooter}</div>`
      this.contentLocal = fullTable
      this._hasPendingChanges = true
      this.$nextTick(() => {
        this.$refs.medicalOrderEditorPreview.editor.commands.setContent(this.contentLocal)
      })
    },
    resetLocalChanges () {
      this.form = { ...dataDefault }
      this._suppressFormCreateWatch = true
      try {
        const parsedFromJson = this.formCreate.content_json ? JSON.parse(appUtils.isJSON(this.formCreate.content_json) ? this.formCreate.content_json : []) : []
        if (this.type === 'create') {
          this.prescriptionLocal = []
          this.updateMedicalOrderTable()
          this.formCreate.content = this.contentLocal
        } else if (this.formCreate.content) {
          this._suppressPrescriptionWatch = true
          this.prescriptionLocal = this.parsePrescriptionFromHtml(this.normalizeIncomingHtml(this.formCreate.content || ''))
          this.contentLocal = this.normalizeIncomingHtml(this.formCreate.content || '')
          this.$nextTick(() => {
            this.$refs.medicalOrderEditorPreview.editor.commands.setContent(this.contentLocal)
            this._suppressPrescriptionWatch = false
          })
        } else if (parsedFromJson && parsedFromJson.length) {
          this._suppressPrescriptionWatch = true
          this.prescriptionLocal = parsedFromJson
          this.$nextTick(() => { this._suppressPrescriptionWatch = false })
        } else {
          this.prescriptionLocal = []
        }
      } catch (e) {
        this.prescriptionLocal = []
      }
      this.$nextTick(() => { this._suppressFormCreateWatch = false })
    },
    loadFromFormCreate (form) {
      const content = this.normalizeIncomingHtml((form && form.content) || '')
      this._suppressFormCreateWatch = true
      this._suppressPrescriptionWatch = true
      this.prescriptionLocal = this.parsePrescriptionFromHtml(content)
      this.contentLocal = content
      this.$nextTick(() => {
        this.$refs.medicalOrderEditorPreview.editor.commands.setContent(this.contentLocal)
        this._suppressPrescriptionWatch = false
        this._suppressFormCreateWatch = false
      })
    },
    parsePrescriptionFromHtml (html) {
      if (!html) return []
      try {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        const tbody = doc.querySelector('tbody')
        if (!tbody) return []
        const rows = Array.from(tbody.querySelectorAll('tr'))
        const dataRows = rows.filter(r => r.querySelectorAll('td').length > 0)

        const rowCount = dataRows.length
        const colCount = 7
        const grid = Array.from({ length: rowCount }, () => Array(colCount).fill(''))

        dataRows.forEach((r, rowIdx) => {
          const tds = Array.from(r.querySelectorAll('td'))
          let cursor = 0
          for (let ci = 0; ci < tds.length; ci++) {
            while (cursor < colCount && grid[rowIdx][cursor] !== '') cursor++
            if (cursor >= colCount) break
            const td = tds[ci]
            const colspan = parseInt(td.getAttribute('colspan')) || 1
            const rowspan = parseInt(td.getAttribute('rowspan')) || 1
            const text = (td.textContent || '').trim()

            for (let c = 0; c < colspan; c++) {
              for (let rOff = 0; rOff < rowspan; rOff++) {
                const rr = rowIdx + rOff
                const cc = cursor + c
                if (rr < rowCount && cc < colCount) {
                  grid[rr][cc] = text
                }
              }
            }
            cursor += colspan
          }
        })

        return grid.map((cols, rowIdx) => {
          const safe = v => (v || '').trim()
          const name = safe(cols[0])
          const dose = safe(cols[1])
          const amountRaw = safe(cols[2])
          const amount = (amountRaw !== '' && !isNaN(Number(amountRaw))) ? Number(amountRaw) : ''
          const volume = safe(cols[3])
          const instructions = safe(cols[4])
          const startRaw = safe(cols[5])
          const parsedStart = this.parseDateText(startRaw)
          const start_time = parsedStart !== '' ? parsedStart : startRaw
          const endRaw = safe(cols[6])
          const parsedEnd = this.parseDateText(endRaw)
          const end_time = parsedEnd !== '' ? parsedEnd : endRaw

          return {
            medicine: { product_info: { name } },
            dose,
            amount,
            amount_unit: '',
            volume,
            instructions,
            start_time,
            end_time
          }
        })
      } catch (e) {
        return []
      }
    },
    parseDateText (text) {
      if (!text) return ''
      let m = text.match(/(\d{1,2}:\d{2}(?::\d{2})?)\s+(\d{1,2})\/(\d{1,2})\/(\d{4})/)
      if (m) {
        let time = m[1]
        if (time.split(':').length === 2) time += ':00'
        const day = m[2].padStart(2, '0')
        const month = m[3].padStart(2, '0')
        const year = m[4]
        const [hh, mm] = time.split(':')
        return `${year}-${month}-${day}T${hh.padStart(2, '0')}:${mm}`
      }
      m = text.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}:\d{2}(?::\d{2})?)/)
      if (m) {
        let time = m[4]
        if (time.split(':').length === 2) time += ':00'
        const day = m[1].padStart(2, '0')
        const month = m[2].padStart(2, '0')
        const year = m[3]
        const [hh, mm] = time.split(':')
        return `${year}-${month}-${day}T${hh.padStart(2, '0')}:${mm}`
      }
      const d = new Date(text)
      if (!isNaN(d)) {
        const yyyy = d.getFullYear()
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const dd = String(d.getDate()).padStart(2, '0')
        const hh = String(d.getHours()).padStart(2, '0')
        const min = String(d.getMinutes()).padStart(2, '0')
        return `${yyyy}-${mm}-${dd}T${hh}:${min}`
      }
      return ''
    }
  }
}
</script>
